module.exports = __webpack_public_path__ + "img/frame-bottom.fbb3fd8c.webp";